import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Compass } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Paths() {
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/paths?lang=${lang}`).then((r) => setItems(r.data.items || []));
  }, [lang]);
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
          <Compass className="w-6 h-6 text-[#C85A32]" /> {t("paths.title")}
        </h1>
        <p className="text-[#4A525A] mt-1">{t("paths.subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-3">
        {items.map((p, idx) => (
          <div
            key={p.letter}
            data-testid={`paths-${p.letter.toLowerCase()}`}
            className={`rounded-2xl p-4 text-center border-2 ${idx % 2 === 0 ? "bg-[#2C4A3E] text-white border-[#1F382E]" : "bg-[#FAF5EC] text-[#1C2024] border-[#E4DDD3]"}`}
          >
            <div className="text-3xl font-extrabold">{p.letter}</div>
            <div className="mt-1 font-bold">{p.name}</div>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        {items.map((p) => (
          <div key={p.letter} className="bg-white border-2 border-[#E4DDD3] rounded-2xl p-5">
            <div className="flex items-baseline gap-3">
              <div className="w-10 h-10 rounded-full bg-[#C85A32] text-white flex items-center justify-center font-extrabold">
                {p.letter}
              </div>
              <div>
                <div className="text-lg font-bold">{p.name}</div>
                <div className="text-[#1C2024] font-medium">{p.question}</div>
              </div>
            </div>
            <p className="mt-3 text-[#4A525A]">{p.prompt}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
